import { type FC } from 'react';
import { getProductTileAdData } from 'dibs-google-ad-manager/exports/adHelpers.ts';
import { ProductTileAd } from 'dibs-google-ad-manager/exports/ProductTileAd.tsx';
import { type AdProductTile } from 'dibs-google-ad-manager/exports/types.ts';
import { useAbsentAdHandler } from 'dibs-google-ad-manager/exports/hooks.ts';

import dibsCss from 'dibs-css';
import classnames from 'classnames';

type Props = {
    adMap: Record<number, Record<number, number>>;
    columnIndex: number;
    index: number;
    placement: string;
    isDesktop: boolean | undefined;
    areDisplayAdsEnabled: boolean | null | undefined;
};

const TileAd: FC<{ ad: AdProductTile }> = ({ ad }) => {
    const { adId, elementId, height, heightHold, width, widthHold, sizes } = ad;
    const { isAbsentAd, onAbsentAd } = useAbsentAdHandler(elementId);

    return isAbsentAd ? null : (
        <div
            className={classnames(
                dibsCss.wFull,
                dibsCss.mbSmall,
                dibsCss.pSmaller,
                dibsCss.border,
                dibsCss.borderSolid,
                dibsCss.borderDolphin
            )}
        >
            <ProductTileAd
                adId={adId}
                elementId={elementId}
                height={height}
                heightHold={heightHold}
                width={width}
                widthHold={widthHold}
                sizes={sizes}
                lazyLoad
                scaleToFit
                onAbsentAd={onAbsentAd}
                containerClassName={dibsCss.minW0}
            />
        </div>
    );
};

export const GridTileAd: FC<Props> = ({
    adMap,
    columnIndex,
    index,
    placement,
    isDesktop,
    areDisplayAdsEnabled,
}) => {
    if (!areDisplayAdsEnabled || !isDesktop) {
        return null;
    }

    const adIndex = adMap[columnIndex]?.[index];
    if (adIndex === undefined) {
        return null;
    }

    const adData = getProductTileAdData({
        uriRef: placement,
        deviceType: 'desktop',
    });

    const ad = adData[adIndex];
    if (!ad) {
        return null;
    }

    return <TileAd ad={ad} />;
};
